<template>
  <div class="px-3">
    <div class="is-size-7 columns mb-2 is-mobile is-vcentered">
      <div
        class="column mr-3 has-text-weight-bold is-size-6 is-uppercase pointer"
        @click="openArchiveList = !openArchiveList"
      >
        {{ $t('archives') }}
      </div>
      <div class="column is-2" @click="openArchiveList = !openArchiveList">
        <vue-icon-base
          v-show="!openArchiveList"
          class="is-pulled-right pointer"
          height="16"
          width="16"
          :path="$options.icons[$kc('uni-plus-circle')]"
        ></vue-icon-base>
        <vue-icon-base
          v-show="openArchiveList"
          class="is-pulled-right pointer"
          height="16"
          width="16"
          :path="$options.icons[$kc('uni-minus-circle')]"
        ></vue-icon-base>
      </div>
    </div>
    <div v-if="archiveList.length">
      <div v-if="openArchiveList">
        <div v-for="(archive, index) in archiveList" :key="index">
          <div class="columns is-multiline is-desktop mb-0 pointer">
            <div
              :class="{
                'is-active has-text-weight-bold has-text-jobseeker': activeClassYear(
                  archive.year
                )
              }"
              class="is-size-8 pb-0 column is-12"
              @click="
                archiveQuery = ''
                showMonthDiv(archive.year)
              "
            >
              {{ `${archive.year} (${archive.total})` }}
            </div>
            <div class="column is-12 pt-0 pl-8">
              <transition name="slide-fade">
                <div v-if="showMonthValues && activeYear === archive.year">
                  <div
                    v-for="(archiveMonth, monthIndex) in archive.months"
                    :key="`month-${monthIndex}`"
                    class="mt-2"
                  >
                    <div
                      class="is-size-8 ml-7 is-uppercase pointer"
                      :class="{
                        'is-active has-text-weight-medium has-text-jobseeker': activeClassMonth(
                          archive.year,
                          archiveMonth.yearmonth
                        )
                      }"
                      @click="gotoArchiveBlog(archiveMonth.yearmonth)"
                    >
                      {{ `${$t(archiveMonth.name)} (${archiveMonth.count})` }}
                    </div>
                  </div>
                </div>
              </transition>
            </div>
            <hr class="mt-2 mb-2" />
          </div>
        </div>
      </div>
    </div>
    <div v-else class="pl-3">
      <vue-no-data :loading="loading"></vue-no-data>
    </div>
  </div>
</template>
<script>
import VueNoData from '@/components/Commons/VueNoData'
import VueIconBase from '@/components/Commons/VueIconBase'
import { uniPlusCircle, uniMinusCircle } from '@/helpers/icons'
export default {
  components: { VueNoData, VueIconBase },
  icons: { uniPlusCircle, uniMinusCircle },
  data() {
    return {
      openArchiveList: false,
      archiveQuery: this.$route.query.archive,
      archiveList: [],
      loading: false,
      showMonthValues: false,
      activeYear: 0
    }
  },
  watch: {
    '$route.query.archive': {
      handler(val) {
        this.showMonthValues = false
        const yearValue = parseInt(val && val.substring(0, 4))
        this.showMonthDiv(yearValue)
      },
      immediate: true
    }
  },
  mounted() {
    this.getArchive()
  },
  methods: {
    getArchive() {
      this.loading = true
      const contentUrl = `/api/v1/blogs/by-archives`
      this.$axios.get(contentUrl).then(response => {
        this.archiveList = response.data
        this.loading = false
      })
    },
    activeClassYear(year) {
      return (
        year === this.activeYear ||
        `${this.archiveQuery}`.substring(0, 4) === year.toString()
      )
    },
    activeClassMonth(yearValue, monthValue) {
      return (
        `${this.$route.query.archive}`.substring(0, 4) ===
          yearValue.toString() &&
        `${this.$route.query.archive}` === monthValue.toString()
      )
    },
    showMonthDiv(year) {
      if (year === this.activeYear) {
        this.showMonthValues = !this.showMonthValues
      } else {
        this.showMonthValues = true
        this.activeYear = year
      }
    },
    gotoArchiveBlog(value) {
      this.$router.push(
        this.localePath({
          name: 'blog',
          query: { archive: value }
        })
      )
    }
  }
}
</script>
<style scoped>
.is-size-8 {
  font-size: 0.85rem;
}
</style>
